import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id?: string;
  label?: string;
  bonus_cost?: string;
  title?: string;
  description?: string;
  image?: string;
};

export const useVehicleMarkSet = () => {
  const [vehicleMarkSetLoading, setVehicleMarkSetLoading] = useState(false);
  const [vehicleMarkSet, setVehicleMarkSet] = useState([]);

  const getVehicleMarkSet = useCallback(async (params: TParams) => {
    setVehicleMarkSetLoading(true);
    const fd = new FormData();
    console.log("create status params", params);
    if (params.id) {
      fd.append("id", params.id);
    }
    if (params.bonus_cost) {
      fd.append("bonus_cost", params.bonus_cost);
    }
    if (params.title) {
      fd.append("title", params.title);
    }
    if (params.description) {
      fd.append("description", params.description);
    }
    if (params.image) {
      fd.append("image", params.image);
    }
    const res = await request({
      path: "promo-status/set",
      method: "POST",
      body: fd,
      requestType: null,
      // body: JSON.stringify(params),
    });
    setVehicleMarkSet(res?.data);
    setVehicleMarkSetLoading(false);
    return res?.data;
  }, []);

  return { vehicleMarkSetLoading, vehicleMarkSet, getVehicleMarkSet };
};
